import React from 'react';

const ExtornarPrestamoModal = ({
  show,
  onClose,
  selectedPrestamo,
  handleConfirmExtornar
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-sm p-6">
        <h3 className="modal-title mb-4">
          ¿Está seguro de extornar el Préstamo #{selectedPrestamo?.idPrestamo}?
        </h3>

        <div className="mb-4">
          <p className="mb-1 text-sm text-slate-600">
            Préstamo: #{selectedPrestamo?.idPrestamo} - {selectedPrestamo?.modalidad}
          </p>
          <p className="mb-1 text-sm text-slate-600">
            Esta acción eliminará el préstamo y no se puede deshacer.
          </p>
        </div>

        <div className="modal-actions border-t border-slate-200 pt-4">
          <button
            onClick={onClose}
            className="btn-modal-neutral"
          >
            Cancelar
          </button>
          <button
            onClick={handleConfirmExtornar}
            className="btn-modal-danger"
          >
            Extornar Préstamo
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExtornarPrestamoModal;
